import { createCachedSelector, defaultKeySelector, path } from '@cbridge-utils/redux';
import { createDefaultCachedSelectorOptions } from '@cbridge-utils/reselect';
import { detailsSidebarStoreSelector, SidebarOpenMode, detailsSidebarResourceIdSelector } from '@cbridge-packages/details-sidebar';

export const streamDetailsPropsSelector = createCachedSelector(
  [
    path(detailsSidebarStoreSelector).mode(),
    detailsSidebarResourceIdSelector,
  ],
  (mode, streamId) => {
    return {
      isCreateMode: mode === SidebarOpenMode.Create,
      streamId: Number(streamId),
    };
  },
)({
  ...createDefaultCachedSelectorOptions(),
  keySelector: defaultKeySelector,
});
